import { useNavigate } from 'react-router-dom';
import { default as Box } from '@mui/material/Box';
import { default as Container } from '@mui/material/Container';
import { LightGrayLabel } from 'components/labels';
import { MenuLink, MenuLinkTitle } from 'components/MenuLink';
import { ErrorFallbackScreen } from 'components/screens';
import { useAssignments } from 'modules/assignments';
import { getTrans } from 'modules/i18n';
import { ASSIGNMENT_STATUS_MAP, StatusBadge } from 'modules/status-badge';
import { AssignmentsSkeleton } from './AssignmentsSkeleton';

export const Assignments = () => {
  const navigate = useNavigate();
  const { assignmentsList, isLoading, isError } = useAssignments();

  if (isLoading) return <AssignmentsSkeleton />;

  if (isError) return <ErrorFallbackScreen />;

  if (!assignmentsList) return null;

  if (!assignmentsList.length)
    return (
      <Box sx={{ textAlign: 'center', p: 5, mt: 10 }}>
        <LightGrayLabel>
          {getTrans('noAssignmentsFound.label.body1')}
        </LightGrayLabel>
        <br />
        <LightGrayLabel>
          {getTrans('noAssignmentsFound.label.body2')}
        </LightGrayLabel>
      </Box>
    );

  return (
    <Container sx={{ px: 0 }}>
      {assignmentsList.map(assignment => (
        <MenuLink
          key={assignment.assignmentRefId}
          onClick={() => {
            navigate(`${assignment.assignmentRefId}`);
          }}
          dataTestId="language-settings-link"
          withArrow={true}
        >
          <Box>
            <MenuLinkTitle sx={{ pb: 1 }}>{assignment.company}</MenuLinkTitle>
            <StatusBadge
              status={assignment.status}
              statusMap={ASSIGNMENT_STATUS_MAP}
            />
          </Box>
        </MenuLink>
      ))}
    </Container>
  );
};
